import { render } from "./InvestmentMultiAsset.vue?vue&type=template&id=12f876fc&scoped=true&ts=true"
import script from "./InvestmentMultiAsset.vue?vue&type=script&lang=ts"
export * from "./InvestmentMultiAsset.vue?vue&type=script&lang=ts"

import "./InvestmentMultiAsset.vue?vue&type=style&index=0&id=12f876fc&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f876fc"]])

export default __exports__